import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../../models/DataModel';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import CompanyMembers from '../MobileSelectProjectMember/MobileCompanyMembers';

import DataSource from '../../../../dao/DataSource/DataSource';
import './MobileSelectProjectMember.scss';

export class MobileSelectProjectMember extends BaseComponent  {
  
  constructor(props){
    super();
    MobileSelectProjectMember.propTypes = {
      project: PropTypes.object.isRequired,
    };
    
    this.state = {
      selectedTabName: this.companyTab,
      editing: false,
      projectMembers: [],
      
    };

    this.current = [];
    this.toBeAdded = [];
    this.toBeRemoved = [];
     
  }

  componentDidMount() {
    const { currentUser } = this.props;
    const currentRole = currentUser ? currentUser.role : null;
    
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    const { project } = this.props;
    const element = document.getElementById('select-project-member-popup' + project.id);
    if (element) {
      element.addEventListener('keydown', this.handleKeyDown);
      element.focus();
    }
    this.setState({ project }, () => {
      this.fetchProject(project);
    });
  }
  
  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.project || !this.props.project || prevProps.project.id != this.props.project.id) {
      this.fetchProject(this.props.project);
    }
  }

  fetchProject(project) {
    const { skipProjectFetch } = this.props;
    if (this.projectDataSource) {
      this.projectDataSource.release();
    }
    this.projectDataSource = new DataSource('Project', project.id, { project: { users: { companies: {} }, teams: { users: {} }, location: { market: {} } } }, this.handleProjectUpdated);
    if (skipProjectFetch) {
      this.setProjectMembersList(project);
    }
    else {
      this.projectDataSource.get();
    }
  }

  handleProjectUpdated(project, action, acData, fetchedData) {
    this.setProjectMembersList(project);
  }

  setProjectMembersList(project) {
    let projectMembers = [];
    if (project && project.users && project.users.length > 0) {
      projectMembers = project.users;
    }
    if (project && project.teams && project.teams.length > 0) {
      // remove all users that belong to member teams
      projectMembers = projectMembers.filter((member) => {
        const userTeam = project.teams.find((team) => {
          const userInTeam = team.users.find((teamUser) => {
            return teamUser.id == member.id;
          });
          return userInTeam;
        });
        return !userTeam;
      });
      projectMembers = projectMembers.concat(project.teams);
    }
    this.toBeAdded = [];
    this.toBeRemoved = [];
    this.current = [...projectMembers];
    this.setState({ project, projectMembers });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleAddRemoveMembers();
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClose();
    }
  }

  selectTab(tabName) {
    this.setState({ selectedTabName: tabName });
  }

  isUser(member) {
    return member.first_name || member.last_name;
  }

  projectHasTeam(team) {
    const { project } = this.state;
    const teamIndex = project.teams.findIndex((projectTeam) => {
      return projectTeam.id == team.id;
    });
    return teamIndex >= 0;
  }

  projectHasUser(user) {
    const { project } = this.state;
    const userIndex = project.users.findIndex((projectUser) => {
      return projectUser.id == user.id;
    });
    return userIndex >= 0;
  }

  isMemberOf(list, member) {
    const indexOf = list.findIndex((listMember) => {
      return (((this.isUser(member) && this.isUser(listMember)) || (!this.isUser(member) && !this.isUser(listMember))) && member.id == listMember.id);
    }, this);
    return indexOf;
  }

  isUserTeamMember(members, member) {
    const indexOf = members.findIndex((memberToCheck) => {
      if (!this.isUser(memberToCheck)) {
        const teamMemberIndex = memberToCheck.users.findIndex((teamMember) => {
          return member.id == teamMember.id;
        });
        return teamMemberIndex >= 0;
      }
      return false;
    });
    return indexOf >= 0;
  }

  setProjectMembers() {
    let projectMembers = [...this.toBeAdded];
    projectMembers = projectMembers.concat(this.current);
    // remove any individual users that are members of a team project member
    projectMembers = projectMembers.filter((member) => {
      return !this.isUser(member) || !this.isUserTeamMember(projectMembers, member);
    }, this);
    this.setState({ projectMembers, editing: this.toBeAdded.length || this.toBeRemoved.length });
  }

  handleAddMember(member) {
    const element = document.getElementById('select-project-member-popup' + this.state.project.id);
    if (element) {
      element.focus();
    }
    const toBeRemovedIndexOf = this.isMemberOf(this.toBeRemoved, member);
    if (toBeRemovedIndexOf >= 0) {
      // if in toBeRemoved then it must have been in current so put it back...
      this.toBeRemoved.splice(toBeRemovedIndexOf, 1);
      this.current.push(member);
    }
    else {
      // a "new" member
      this.toBeAdded.push(member);
     
    }
    this.handleAddRemoveMembers();
    this.setProjectMembers();
  }

  handleRemoveMember(member) {
    const { project } = this.state;
    const { currentUser } = this.props;
    if (this.isUser(member)) {
      if (project.company_id == member.primary_company_id && !(currentUser.primary_company_id == project.company_id || this.props.permissions.isSuperUser)) {
        return;
      }
      if (this.isMemberOf(this.toBeAdded, member) < 0) {
        dataModel.projectsDAO.countUserAssignments(project, member.id).then(userCounts => {
          if (userCounts && ((userCounts.user_assignments_total && userCounts.user_assignments_total.task_count) || (userCounts.user_assignments_total && userCounts.user_assignments_total.build_count))){
            this.handleOkToRemoveMember(member, project, userCounts.user_assignments_total);
          }
          else  {
            this.handleFinishRemoveMember(member, project);
          }
        });
      }
      else {
        this.handleFinishRemoveMember(member, project);
      }
    }
    else {
      if (member.company_id != currentUser.primary_company_id && !this.props.permissions.isSuperUser) {
        return;
      }
      if (this.isMemberOf(this.current, member) >= 0) {
        dataModel.teamsDAO.checkProjectUsage(member.id, project.id)
        .then((response) => {
          if (response.message && response.message == 'true') {
            this.handleOkToRemoveMember(member, project);
          }
          else {
            this.handleFinishRemoveMember(member, project);
          }
        });
      } 
      else {
        this.handleFinishRemoveMember(member, project);
      }
    }
  }

  handleOkToRemoveMember(member, project, userCounts) {
    let messageText = '';
    let height = 184;
    if (this.isUser(member)) {
      if (userCounts.task_count && userCounts.build_count) {
        messageText = member.name + ' is assigned to ' + userCounts.task_count + ' Task' + (userCounts.task_count > 1 ? 's' : '') + ' and ' + userCounts.build_count + ' Build' + (userCounts.build_count > 1 ? 's' : '') + '. Removing them from the Project will remove their assignments.';
      }
      else if (userCounts.build_count) {
        messageText = member.name + ' is assigned to ' + userCounts.build_count + ' Build' + (userCounts.build_count > 1 ? 's' : '') + '. Removing them from the Project will remove their assignments.';
      }
      else {
        messageText = member.name + ' is assigned to ' + userCounts.task_count + ' Task' + (userCounts.task_count > 1 ? 's' : '') + '. Removing them from the Project will remove their assignments.';
      }
    }
    else {
      height = 200;
      messageText = 'One or more members of this team are assigned to at least one task or build. Removing the team will remove these assignments.';
    }
    const message = (
      <div>
        <p>{messageText}</p>
      </div>
    );

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      height: height,
      width: 320,
      message: message,
      cancelButtonText: 'Cancel',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.handleFinishRemoveMember(member, project);
      },
      handleOwnerCancel: () => {
        this.handleClose();
      },
    });
  }

  handleFinishRemoveMember(member) {
    const element = document.getElementById('select-project-member-popup' + this.state.project.id);
    if (element) {
      element.focus();
    }
    const toBeAddedIndexOf = this.isMemberOf(this.toBeAdded, member);
    if (toBeAddedIndexOf >= 0) {
      // not a current member so just remove...
      this.toBeAdded.splice(toBeAddedIndexOf, 1);
    } 
    else {
      const currentIndexOf = this.isMemberOf(this.current, member);
      if (currentIndexOf >= 0) {
        this.current.splice(currentIndexOf, 1);
        this.toBeRemoved.push(member);
      }
    }
    this.handleAddRemoveMembers();
    this.setProjectMembers();
  }

  removeMembers(project, members) {
    for (let member of members) {
      this.removeMemberFromProject(member, project);
    }
  }

  addMembers(project, members) {
    for (let member of members) {
      this.addMemberToProject(member, project);
    }
  }

  handleAddRemoveMembers() {
    const clonedProject = _.cloneDeep(this.state.project);
    // removes before adds...
    this.removeMembers(clonedProject, this.toBeRemoved);
    this.addMembers(clonedProject, this.toBeAdded);
    this.doClose();
  }

  // The next 2 functions are for updating the UI without having to wait on API requests
  addMemberToProject(member, project) {
    if (this.isUser(member)) {
      if (project.users && !project.users.find(usr => usr.id == member.id)) {
        project.users.push(member);
      }
      this.projectDataSource.performAction('addUserToProject', member, this.state.project).then(project => {

      })
      .catch(error => {
        // undo the adds in state
        const clonedProject = _.cloneDeep(this.state.project);
        _.remove(clonedProject.users, usr => usr.id == member.id);
        this.props.updateProject(clonedProject);
      });
    }
    else {
      if (project.teams && !project.teams.find(team => team.id == member.id)) {
        project.teams.push(member);
      }
      this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaProject');
      dataModel.teamsDAO.addTeamProject(member, project.id, null, null, null)
      .then((team) => {
        // TODO: ?
      })
      .catch(error => {
        // undo the adds in state
        const clonedProject = _.cloneDeep(this.state.project);
        _.remove(clonedProject.teams, team => team.id == member.id);
        this.props.updateProject(clonedProject);
      });
    }
  }

  removeMemberFromProject(member, project) {
    if (this.isUser(member)) {
      if (project.users && project.users.find(usr => usr.id == member.id)) {
        _.remove(project.users, usr => usr.id == member.id);
      }
      this.projectDataSource.performAction('removeUserFromProject', member, project)
      .catch(error => {
        // undo the deletions in state
        const clonedProject = _.cloneDeep(this.state.project);
        if (!clonedProject.users.find(usr => usr.id == member.id, this)) {
          clonedProject.users.push(member);
          this.props.updateProject(clonedProject);
        }
      });
    }
    else {
      dataModel.teamsDAO.removeTeamProject(member, project.id, null)
      .then((team) => {
        // TODO: ?
      })
      .catch(error => {
        // undo the deletions in state
        const clonedProject = _.cloneDeep(this.state.project);
        if (!clonedProject.teams.find(team => team.id == member.id, this)) {
          clonedProject.teams.push(member);
          this.props.updateProject(clonedProject);
        }
      });
    }
  }

  handleClose() {
    if (this.state.editing) {
      this.queryClose();
    }
    else {
      this.doClose();
    }
  }

  queryClose() {
    const message = this.textMap.queryUsersChanged;

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.no.toUpperCase(), 
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300, 
      height: 175, 
      handleOwnerOk: this.doClose, 
    });
  }

  doClose() {
    dataModel.systemPopup = null;
    this.setState({ animateClose: true });
  }

  handleAnimateOut() {
    if (this.props.handlePopupClose) {
      this.props.handlePopupClose();
    }
  }

  handleBackgroundClicked(e) {
    if (e.target.className == 'select-project-member-background') {
      this.handleClose();
    }
  }
  render() {
    let { project } = this.state;
    if (!project) {
      project = this.props.project;
    }
    
    // let tabItems = null
    // if (this.props.permissions && (this.props.permissions.isSuperUser || ((this.props.currentUser.role.name == "admin" || this.props.currentUser.role.name == "editor") && this.props.currentUser.primary_company_id == this.props.currentCompany.id))) {
    //   tabItems = [this.companyTab, this.teamsTab]
    // }
    // else {
    //   selectedTabName = this.companyTab
    //   tabItems = [this.companyTab]
    // }

    return (
    <div className="mobile-projectmembers-container">
          <CompanyMembers 
            project={this.props.project} 
            multiSelect={true} 
            type={null}
            handleAddMember={this.handleAddMember}
            handleRemoveMember={this.handleRemoveMember}
            projectMembers={this.state.projectMembers}
          />
        
      </div>
   );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(MobileSelectProjectMember));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/MobileSelectProjectMember/index.js